<template>
  <div class="account-verification-page min-h-screen relative shadow-lg">
    <BlNavBarMv
      title="Verifikasi Akun"
      has-back-button
      class="sticky top-0"
      style="border-bottom: 1px solid #ebebeb"
      @handleBackButtonClick="onClickBack"
    />
    <div class="page__body">
      <div class="mh-20 pt-20">
        <PrakerjaOtpBox :is-error="otp.error" @onRetrievePayload="retrievePayload" />
      </div>

      <BlLoadingDialogMv :is-active="isInquiring" />
    </div>
    <footer style="max-width: 480px; margin: 0 auto" class="fixed w-full">
      <div
        class="pv-12 ph-20 border-t border-0 border-gray-5 border-solid bottom-0 fixed w-full bg-white"
        style="max-width: 480px; margin: 0 auto"
      >
        <BlButtonAv :is-loading="isInquiring" variation="primary" class="account-verification__verify" fullwidth @click="createTransaction">
          Verifikasi
        </BlButtonAv>
      </div>
    </footer>

    <BlSheetMv
      :active.sync="sheet.showWrongOtpSheet"
      class="qa-sheet-error-message"
      title=""
      auto-height
      :is-draggable="false"
      @close="redirectToLandingPage"
    >
      <i slot="iconLeftNavBar"></i>
      <div slot="content" style="padding: 16px">
        <center>
          <BlIllustrationAv alt="Failed OTP 3 times attempt" class="prakerja-verify-otp__sheet-image" name="img_medium_fun_sad" />
          <BlTextAv class="qa-txt-title-error" variation="subheading-18">
            Maaf, kamu udah melewati batas 3 kali percobaan verifikasi
          </BlTextAv>
          <BlTextAv class="qa-txt-subtitle-error mt-12 mb-20 block" variation="body-14">
            Untuk keamanan akun, kamu perlu menunggu selama 24 jam untuk bisa verifikasi lagi.
          </BlTextAv>
          <BlButtonAv data-test="handle-redirect-to-landing-cta" class="mt-12" fullwidth @click="redirectToLandingPage">
            Kembali ke halaman utama
          </BlButtonAv>
        </center>
      </div>
    </BlSheetMv>

    <BlSheetMv
      :active.sync="sheet.showBackSheet"
      class="qa-sheet-back-handler"
      title=""
      auto-height
      :is-draggable="false"
      @close="onClickBack"
    >
      <div slot="content" style="padding: 16px">
        <center>
          <BlIllustrationAv alt="Back handler" class="prakerja-verify-otp__sheet-image" name="img_medium_fun_search_fail" />
          <BlTextAv class="qa-txt-title-back" variation="subheading-18">Batalkan verifikasi?</BlTextAv>
          <BlTextAv class="qa-txt-subtitle-back mt-12 mb-20 block" variation="body-14">
            Pembayaran akan dibatalkan dan kamu perlu menunggu 15 menit untuk bisa dapat kode verifikasi lagi.
          </BlTextAv>
          <BlButtonAv data-test="handle-cancel-back-cta" class="mt-12" fullwidth @click="onCancelBack">Lanjutkan verifikasi</BlButtonAv>
          <BlButtonAv data-test="handle-execute-back-cta" class="mt-12" fullwidth variation="outline" @click="handleBack">
            Ya, batalkan
          </BlButtonAv>
        </center>
      </div>
    </BlSheetMv>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {debounce} from 'lodash';
import {BlButtonAv, BlLoadingDialogMv, BlNavBarMv, BlSheetMv, BlTextAv} from '@bukalapak/bazaar-mweb-latest';
import {BlIllustrationAv} from '@bukalapak/bazaar-visual-next';
import PrakerjaOtpBox from '../components/PrakerjaAccountVerification/PrakerjaOtpBox.vue';
import trackerGenerator from '../mixins/tracker-generator';
import {TRACKER_EVENT_VP_PRAKERJA_OTP} from '../config/tracker-events';
import Braze from 'shared_js/helpers/braze';
import moment from 'moment';
moment.locale('id');

const THREE_TIMES_OTP_ERROR_CODE = 'ERRPLT40033';
const WRONG_OTP_ERROR_CODE = 'ERRPLT40038';

const DEBOUNCE_WAIT_TIME = 500;
const timeZone = {
  WIB: '+07:00',
  WITA: '+08:00',
  WIT: '+09:00',
};

export default {
  name: 'AccountVerificationPage',
  components: {
    BlNavBarMv,
    BlLoadingDialogMv,
    BlButtonAv,
    PrakerjaOtpBox,
    BlSheetMv,
    BlIllustrationAv,
    BlTextAv,
  },
  mixins: [trackerGenerator],
  data: () => ({
    prevRoute: null,
    inquiryData: null,
    isInquiring: false,
    errorMessage: '',
    invoiceId: '',
    payload: {
      id: null,
      token: '',
      otp: '',
    },
    showErrorMessage: false,
    otp: {
      count: 0,
      error: false,
    },
    sheet: {
      showBackSheet: false,
      showWrongOtpSheet: false,
    },
  }),
  computed: {
    ...mapGetters(['getPreviousPage']),
    ...mapGetters('courses', ['getDetailCourse']),
    courseSchedule() {
      const scheduleCode = this.$route.query?.schedule_code;
      const schedule = this.getDetailCourse?.course_schedules.find((courseSchedule) => courseSchedule.schedule_code === scheduleCode);

      return schedule;
    },
    scheduleClassStart() {
      return this.courseSchedule?.times.reduce((earliestSchedule, currentSchedule) => {
        const currentTimezone = timeZone[currentSchedule?.timezone?.toUpperCase()] || '+07:00';
        const earliestTimezone = timeZone[earliestSchedule?.timezone?.toUpperCase()] || '+07:00';

        const currentDateTime = moment(
          `${currentSchedule.schedule_date}T${currentSchedule.start_time} ${currentTimezone}`,
          'YYYY-MM-DDTHH:mm Z'
        );
        const earliestDateTime = moment(
          `${earliestSchedule.schedule_date}T${earliestSchedule.start_time} ${earliestTimezone}`,
          'yyyy-MM-DDTHH:mm Z'
        );

        return currentDateTime.valueOf() < earliestDateTime.valueOf() ? currentSchedule : earliestSchedule;
      }, this.courseSchedule?.times?.[0]);
    },
    scheduleClassEnd() {
      return this.courseSchedule?.times.reduce((latestSchedule, currentSchedule) => {
        const currentTimezone = timeZone[currentSchedule?.timezone?.toUpperCase()] || '+07:00';
        const latestTimezone = timeZone[latestSchedule?.timezone?.toUpperCase()] || '+07:00';

        const currentDateTime = moment(
          `${currentSchedule.schedule_date}T${currentSchedule.end_time} ${currentTimezone}`,
          'yyyy-MM-DDTHH:mm Z'
        );
        const latestDateTime = moment(`${latestSchedule.schedule_date}T${latestSchedule.end_time} ${latestTimezone}`, 'yyyy-MM-DDTHH:mm Z');

        return currentDateTime > latestDateTime ? currentSchedule : latestSchedule;
      }, this.courseSchedule?.times?.[0]);
    },
  },
  beforeMount() {
    if (!this.$root.prakerjaToken) this.redirectToLandingPage();
    this.init();
  },
  methods: {
    init() {
      if (!this.getDetailCourse) {
        const arrayAttributeCourse = this.$route.query?.course?.split?.('||');
        const courseId = arrayAttributeCourse?.[0];

        this.$store.dispatch('courses/fetchCourseDetail', courseId);
      }
    },
    handleBack() {
      document.body.style.overflow = 'auto';
      this.redirectToLandingPage();
    },
    onClickBack() {
      this.sheet.showBackSheet = true;
    },
    onCancelBack() {
      this.sheet.showBackSheet = false;
    },
    retrievePayload(otpNumber) {
      this.payload.id = this.$root.transactionId;
      this.payload.token = this.$root.prakerjaToken;
      this.payload.otp = otpNumber;
    },
    createTransaction: debounce(async function () {
      if (this.isInquiring) return;

      try {
        this.isInquiring = true;
        this.otp.count += 1;
        this.otp.error = false;

        const {data} = await this.$root.$api.postFinalizeTransaction(this.payload);

        this.invoiceId = data.invoice_id;
        this.clearErrorResponse();
        this.$root.prakerjaToken = null;

        window.dataLayer?.push?.({
          event: 'facebook.Purchase',
          PurchasePayload: {
            contents: [{id: `prakerja_${this.getDetailCourse.id}`, quantity: 1}],
            content_type: 'product',
            value: this.getDetailCourse?.discount?.original_price,
            currency: 'IDR',
          },
        });

        window.dataLayer?.push?.({
          event: 'prakerja.Purchase',
          transactionId: this.getDetailCourse.id,
          transactionTotal: this.getDetailCourse?.discount?.original_price,
        });

        if (window.fbq) {
          window.fbq('trackCustom', 'purchase_prakerja', {
            product_id: this.getDetailCourse?.id,
            product_name: this.getDetailCourse?.name,
            quantity: 1,
            category: this.getDetailCourse?.category.name,
            provider: this.getDetailCourse?.deal.merchant.name,
            total_price: this.getDetailCourse?.discount.original_price,
            currency: 'IDR',
          });
        }

        await Promise.all([this.trackTransactionEvent(), this.trackPrakerjaOtp(true).catch((e) => e)]);
        this.$router.replace(`/transaksi/${this.$root.transactionId}`);
      } catch (err) {
        this.setErrorResponse(err);
        this.$logger.log('PrakerjaAccountVerificationPage - createTransaction', err);
      } finally {
        this.isInquiring = false;
      }
    }, DEBOUNCE_WAIT_TIME),
    setErrorResponse(err) {
      this.errorMessage = 'Terjadi gangguan. Silakan coba lagi nanti.';

      if (err.errors?.length) {
        if (err.errors[0].original_error_code === THREE_TIMES_OTP_ERROR_CODE) {
          this.sheet.showWrongOtpSheet = true;
          this.trackPrakerjaOtp(false);
          return;
        }

        if (err.errors[0].original_error_code === WRONG_OTP_ERROR_CODE) {
          this.otp.error = true;
          return;
        }

        this.errorMessage = err.errors[0].message;
      }

      this.trackPrakerjaOtp(false);
      this.$store.dispatch('onSnackbarShow', {error: this.errorMessage});
      this.$router.go(-1);
    },
    clearErrorResponse() {
      this.errorMessage = '';
    },
    redirectToLandingPage() {
      this.$router.replace({name: 'landing', query: this.$route.query});
    },
    redirectToCouponDetailPage() {
      const originHost = window.location.origin;
      window.location.replace(`${originHost}/kupon/kuponkamu`);
    },
    redirectToInvoiceListPage() {
      const originHost = window.location.origin;
      window.location.replace(`${originHost}/payment/invoices`);
    },
    trackPrakerjaOtp(isSuccess) {
      const payload = {
        otp_try_count: this.otp.count,
        otp_success_count: isSuccess ? 1 : 0,
        otp_failed_count: isSuccess ? this.otp.count - 1 : this.otp.count,
      };
      return this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_OTP, payload);
    },
    async trackTransactionEvent() {
      const payload = {
        product_name: this.getDetailCourse?.name,
        category: this.getDetailCourse?.category.name,
        provider: this.getDetailCourse?.deal.merchant.name,
        total_price: this.getDetailCourse?.discount.original_price,
        schedule_name: this.courseSchedule?.schedule_name,
        schedule_class_start: `${this.scheduleClassStart.schedule_date} ${this.scheduleClassStart.start_time}`,
        schedule_class_finished: `${this.scheduleClassEnd.schedule_date} ${this.scheduleClassEnd.end_time}`,
      };
      await Braze.sendImmediateEvent('prakerja_transaction_paid', payload);
    },
  },
};
</script>

<style lang="scss" scoped>
.page__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.prakerja-verify-otp {
  &__sheet-image {
    &::v-deep {
      img {
        width: 264px;
      }
    }
  }

  &__sheet {
    &::v-deep {
      .bl-sheet__box {
        height: auto !important;
      }
      .bl-sheet__nav-bar {
        display: none;
      }
    }
  }
}
</style>
